import React from 'react';
import { Button, ProgressBar } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { couponBenefits } from '../../utils/couponCategories';
import { formatMoney } from '../../utils/formatMoney';
import './styles/benefitApplicationCard.scss';

function BenefitApplicationCardComponent(props) {
  const { item, category, userName, priority, id } = props;
  const benefit = couponBenefits.find((item) => {
    return item.id === category;
  });
  //console.log('couponBenefits:', couponBenefits);

  const handleClick = () => {
    props.history.push(`/ayudas/bono/${id}`);
  };

  return (
    <div className='benefit-application-card-component'>
      <div className='benefit-thumbnail-container'>
        <div
          className='benefit-thumbnail'
          style={{ backgroundImage: `url(${benefit.thumbnail})` }}
        />
      </div>
      <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <div className='benefit-name'>Solicitud de {benefit.name}</div>
        <div className='user-name'>
          {userName && <>Solicitado por {userName}</>}
        </div>
        <div className={`benefit-priority ${priority}`}>
          <span></span>
          Prioridad{' '}
          {priority === 'HIGH'
            ? 'alta'
            : priority === 'MEDIUM'
            ? 'media'
            : 'baja'}
        </div>
        <div className='benefit-amount'>
          {item.benefitAmount > 0 && (
            <div className='benefit-progress-bar'>
              <div className='progress-label'>
                {`${
                  !item.amountRaised
                    ? 0
                    : formatMoney(Math.floor(item.amountRaised))
                } de ${formatMoney(item.benefitAmount)}`}
              </div>
              <ProgressBar
                now={
                  !item.amountRaised
                    ? 0
                    : (item.amountRaised / item.benefitAmount) * 100
                }
              />
            </div>
          )}
        </div>
        <Button
          onClick={handleClick}
          className='app-button benefit-button'>
          Ver más
        </Button>
      </div>
    </div>
  );
}

export default withRouter(BenefitApplicationCardComponent);
